import React, { useState } from 'react'
import { Box, TextField, Typography } from '@material-ui/core'
import Alert from '@material-ui/lab/Alert'

import { Button } from '../../../components/Wrappers'
import { useHelperStyles } from '../../../styles'
import { copyToClipboard } from '../../../utils/clipboard'

// Shown after an invitation is issued. The link is always displayed, even when
// the email went out fine, so an admin can pass it on themselves - and so a
// failed send is recoverable without creating the user again.
const InviteLink = ({ inviteLink, emailSent, emailError, email }) => {
    const helperClasses = useHelperStyles()
    const [copied, setCopied] = useState(false)

    const handleCopy = async () => {
        const success = await copyToClipboard(inviteLink)
        setCopied(success ? 'yes' : 'no')
    }

    return (
        <Box>
            {/* emailSent is left undefined when no email was attempted (the
                "copy the link" path), so the three cases stay distinguishable. */}
            {emailSent === true &&
                <Alert severity="success" className={helperClasses.marginTopBottom}>
                    An invitation email was sent to {email}.
                </Alert>
            }
            {emailSent === false &&
                <Alert severity="warning" className={helperClasses.marginTopBottom}>
                    The invitation email could not be sent
                    {emailError ? ` (${emailError})` : ''}. Copy the link below and send it yourself.
                </Alert>
            }
            {emailSent === undefined || emailSent === null
                ? <Alert severity="info" className={helperClasses.marginTopBottom}>
                    No email was sent. Copy the link below and send it to {email} yourself.
                  </Alert>
                : null
            }
            <Typography variant="body2" color="textSecondary">
                This link lets {email} choose a password. It expires in 7 days and can only be used once.
            </Typography>
            <TextField
                value={inviteLink}
                label="Invitation link"
                variant="outlined"
                margin="normal"
                size="small"
                fullWidth
                multiline
                InputProps={{ readOnly: true }}
                onFocus={event => event.target.select()}
            />
            <Box display="flex" alignItems="center">
                <Button variant="contained" color="primary" onClick={handleCopy}>
                    Copy link
                </Button>
                {copied === 'yes' &&
                    <Typography variant="body2" className={helperClasses.marginLeft}>Copied.</Typography>
                }
                {copied === 'no' &&
                    <Typography variant="body2" className={helperClasses.marginLeft}>
                        Could not copy automatically - select the link above and copy it.
                    </Typography>
                }
            </Box>
        </Box>
    )
}

export default InviteLink
